import React, { useEffect, useState } from 'react'
import { Wrapper } from '../../style'
import Tree from 'components/Tree'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertion'
import { EmptyText, Empty } from 'components/CommonStyles'

const DegreeAndDepartmentFilter = ({
  checkedKeys,
  setCheckedKeys,
  setCheckedIds,
  degreeList,
}) => {
  const [degreeData, setDegreeData] = useState([])

  const onCheck = (activeKeys, info) => {
    setCheckedKeys(activeKeys)

    let activeIds = info?.checkedNodes
      ?.filter(item => Object.keys(item)?.length <= 2)
      ?.map(id => id?.value)

    setCheckedIds(activeIds)
  }

  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: degreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'streams',
      childrenValueParam: 'degreeStreamMapId',
    })
    setDegreeData(updatedData || [])
  }, [degreeList])

  return (
    <Wrapper column>
      {degreeData?.length ? (
        <Tree
          treeData={degreeData}
          onCheck={onCheck}
          checkedKeys={checkedKeys}
        />
      ) : (
        <Empty
          padding={'50px 0px 0px 0px'}
          height={'75px'}
          description={<EmptyText size={'9px'}>No degree found!</EmptyText>}
        />
      )}
    </Wrapper>
  )
}

export default DegreeAndDepartmentFilter
